import { AbstractEntity } from '@app/shared/abstract/abstract-entity';
import { ProductVariantModel } from './product-variant.model';

export interface ProductModel extends AbstractEntity {
  [key: string]: any;

  name: string;
  description: string;
  price: number;
  price_formatted: string;
  price_can_be_changed: boolean;
  in_stock: boolean;
  status: 'Active' | 'Inactive';
  category:
    | 'Venue Hire'
    | 'Accommodation'
    | 'Wedding Morning Ideas – Food'
    | 'Wedding Morning Ideas – Drink'
    | 'Canapes'
    | 'Reception Drinks'
    | 'Wedding Breakfast Menus'
    | 'Drinks Packages'
    | 'Wine List'
    | 'Evening Food'
    | 'Evening Food – Complimentary'
    | 'Complimentary Items'
    | 'Extras – Food'
    | 'Extras – Drink'
    | 'DJ & Entertainment'
    | 'DJ/Entertainment'
    | 'Hire Items'
    | 'Décor'
    | 'Floristry'
    | 'Miscellaneous'
    | 'Supplier Meals'
    | 'Security Retainer';
  destined_for: 'Adults' | 'Children' | 'Toddler';
  is_minimum_spend: boolean;
  is_variant_based?: boolean;
  counts_to_500_deal: boolean;
  inc_in_150_free: boolean;
  triggers_accommodation_tab?: boolean;
  available_from?: string | null;
  available_until?: string | null;

  variants: ProductVariantModel[];
  variant_ids: number[];

  // media URLs
  images: { sm: string; md: string; lg: string; xl: string }[];
  image_1_sm: string;
}

export class ProductModelUtils {
  static getCategoryColor(category: ProductModel['category']): string {
    switch (category) {
      case 'Wedding Morning Ideas – Food':
      case 'Canapes':
      case 'Wedding Breakfast Menus':
      case 'Evening Food':
      case 'Evening Food – Complimentary':
      case 'Extras – Food':
      case 'Supplier Meals':
        return 'primary';
      case 'Complimentary Items':
        return 'success';
      case 'Wedding Morning Ideas – Drink':
      case 'Reception Drinks':
      case 'Drinks Packages':
      case 'Wine List':
      case 'Extras – Drink':
        return 'info';
      case 'Venue Hire':
        return 'secondary';
      case 'Accommodation':
        return 'success';
      case 'DJ & Entertainment':
      case 'DJ/Entertainment':
        return 'warning';
      case 'Hire Items':
      case 'Décor':
      case 'Floristry':
        return 'light';
      case 'Security Retainer':
        return 'error';
      case 'Miscellaneous':
        return 'dark';
      default:
        return 'light';
    }
  }

  static getStatusColor(status: ProductModel['status']): string {
    switch (status) {
      case 'Active':
        return 'success';
      case 'Inactive':
        return 'error';
      default:
        return 'light';
    }
  }
}
